<script>
	import Error403 from './../../components/Error403.svelte';
	import EditableCell from './../../components/EditableCell.svelte';
	import Loader from './../../components/Loader.svelte';
    import {onMount} from 'svelte';

    import AlteryxService from "../../services/alteryx.service";

    export let params, errorMessage;
    let files, dataFile = null, uploadingCSV = false, uploadedError = "", emails, importType = "roas_monthly", loading = false;
    let isAllowed = true; // Allow to display this section

    let message = {
        show: false,
        type: "",
        text: ""
    }
     
    onMount( async () => {
        await userAllowed();
        if(isAllowed){
            getAlteryxEmails();
        }
    });

    let tab = "csv";

    // Verify if user has permission to see this section 
    async function userAllowed() {
        // loading = true;
        try {
            const response = await AlteryxService.isAllowed();
            if (response && response.data.ok) {
                isAllowed = response.data.ok;
            }
            loading = false;
        } catch (e) {
            console.log(e);
            errorMessage = e.message;
        } finally {
            // loading = false;
            if (ENVIRONMENT.IS_OPERATIONS_KPIS) isAllowed = true;
        }
    }

    async function getAlteryxEmails() {
        loading = true;
        try {
            const response = await AlteryxService.getEmails();

            if (response && response) {
                emails = response;
            }
        } catch (e) {
            console.log(e);
            errorMessage = e.message;
        } finally {
            loading = false;
        }
    }

    let uploadCSV = async function() {
        const formData = new FormData();
        formData.append('file', files[0]);
        uploadingCSV = true;
        uploadedError = "";
        loading = true;

        try {
            const response = await AlteryxService.uploadCSV(formData, importType);
            if (response && response.data.ok) {
                message = {
                    show: true,
                    text: "CSV imported successfully",
                    type: "success"
                }
            }else{
                message = {
                    show: true,
                    text: "Error: " + response.data.error,
                    type: "danger"
                }
            }
        } catch (e) {
            message = {
                show: true,
                text: "Error: " + e.message,
                type: "danger"
            }
        } finally {
            loading = false;
        }
    }

    let updateEmails = async function() {
        loading = true;
        try {
            const response = await AlteryxService.updateEmails({emails});

            if (response && response.data.ok) {
                message = {
                    show: true,
                    text: "Email accounts updated",
                    type: "success"
                }
            }else{
                message = {
                    show: true,
                    text: "Error: " + response.data.error,
                    type: "danger"
                }
            }
        } catch (e) {
            message = {
                show: true,
                text: "Error: " + e.message,
                type: "danger"
            }
        } finally {
            loading = false;
        }
    }

    let resetMessage = function(){
        message = {
            show: false,
            text: "",
            type: ""
        }
    }

</script>

<a id="download_csv" class="d-none" href="#" download="alteryx.csv"> </a>
{#if !isAllowed}
    <div class="row">
        <div class="col">
            <Error403></Error403>
        </div>
    </div>
{:else}
    <div id="pageDiv">
        <main class="pt-3 container">
            <div class="row">
                <div class="col">
                    <h3>Alteryx Catalog</h3>
                    <p>
                        <a class="navbar-brand" href="/dashboard"><small><i class="fa fa-angle-left"></i> Back to the Dashboard</small></a>
                    </p>
                    <ul class="nav nav-pills nav-fill">
                        <li class="nav-item">
                            <button class="general-tabs btn-block btn-default  {(tab == 'emails')?'active':''}" on:click={ () => tab = 'emails'}>Emails</button>
                        </li>
                        <li class="nav-item">
                            <button class="general-tabs btn-block btn-default  {(tab == 'csv')?'active':''}" on:click={ () => tab = 'csv'}>Upload CSV</button>
                        </li>
                    </ul>
                    {#if message.show}
                        <div class="alert alert-{message.type} mt-3" id="message" role="alert">
                            {message.text}
                            <span class="float-right pointer" on:click={ resetMessage }>x</span>
                        </div>
                    {/if}                   
                    <hr>
                    { #if  tab == 'emails'}
                        <div class="row">
                            <div class="col-md-12">
                                <label>Email recipients:</label>
                                <textarea id="emails-textarea" type="text" bind:value={emails} placeholder="example1@mail.com, example2@mail.com ..." class="form-control"></textarea>
                                <p><small>Input email accounts separated by a comma</small></p>
                                <button class="btn btn-success mt-2" on:click={ updateEmails }>Update</button>
                            </div>
                        </div>
                    {:else}
                        <div class="row">
                            <div class="col-md-10 offset-2">
                                <label>Select the report you want to import</label>
                            </div>
                            <div class="col-md-10 offset-2 mb-3 mt-3">
                                <label class="radio-inline mr-2">
                                    <input class="mr-1" type="radio" name="rbt_import" bind:group={importType} value="roas_monthly">Monthly
                                </label>
                                <label class="radio-inline mr-2">
                                    <input class="mr-1" type="radio" name="rbt_import" bind:group={importType} value="roas_quarterly">Quarterly
                                </label>
                                <label class="radio-inline">
                                    <input class="mr-1" type="radio" name="rbt_import" bind:group={importType} value="roas_individual_performance">Individual
                                </label>
                            </div>
                            <div class="col-4 offset-2">
                                <input type="file" class="form-control-file" bind:files />
                            </div>
                            <div class="col-3 text-right">
                                {#if files}
                                    <button class="btn btn-success" on:click={uploadCSV}>Upload</button>
                                {:else}
                                    <button class="btn btn-success" disabled>Upload</button>
                                {/if}
                            </div>
                            <div class="col-md-4 offset-2 mt-5 text-left">
                                <a href="https://s3.us-west-2.amazonaws.com/roas-riverside-kpis.seagage.com/import+templates/{importType}.csv" download class="btn btn-download">
                                    <i class="fa fa-book mr-1"></i>
                                    Download CSV as Template
                                </a>
                            </div>
                            <div class="col-md-3 mt-5 text-right">
                                <a href="https://s3.us-west-2.amazonaws.com/roas-riverside-kpis.seagage.com/ROAS+Data+Import+Learning+Guide.pdf" target="_blank" class="btn btn-download">
                                    <i class="fa fa-file-excel-o mr-1"></i>
                                    Read Learning Guide
                                </a>
                            </div>
                        </div>
                    {/if}     
                </div>
            </div>
        </main>
    </div>
{/if}

<style>
    #col-kpis-kpiId{
        min-width: 100px;
    }
    #col-kpis-piNameColumn{
        min-width: 200px;
    }
    #col-kpis-role{
        min-width: 200px;
    }
    #col-kpis-report{
        min-width: 140px;
    }
    #col-kpis-organization{
        min-width: 150px;
    }
    #col-kpis-format{
        min-width: 130px;
    }
    #col-kpis-code{
        min-width: 160px;
    }
</style>